import React, { Fragment } from 'react';
import { Checkbox } from 'semantic-ui-react';

import ErrorMessage from './errorMessage';

const HHCheckbox = ({ field, form: { touched, errors, setFieldValue }, otherProps = {} }) => {
  const { isReversed, ...restOtherProps } = otherProps;
  const checked = isReversed ? !field.value : field.value;
  const hasError = !!(touched[field.name] && errors[field.name]);


  return (
    <Fragment>
      <Checkbox
        checked={checked}
        onChange={() => {
          setFieldValue(field.name, !field.value);
        }}
        {...restOtherProps}
      />
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default HHCheckbox;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhCheckbox.js